import React from 'react';
import IconFont from '@meitu/xdesign-icon-font';
import './effect-wrap.less';

const EffectWrap: React.FC<{
    title: string;
    iconName: string;
    open: boolean;
    setOpen: (open: boolean) => void;
    children?: React.ReactNode;
}> = ({ children, title, iconName, open, setOpen }) => {
    return (
        <div
            className="c-image-effect-itemWrap"
            style={{
                backgroundColor: `${open ? 'var(--white-opacity-100)' : 'var(--background-web-secondary)'}`,
                boxShadow: `${
                    open ? '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px 2px 8px 0px rgba(0, 0, 0, 0.06)' : 'none'
                }`,
                border: `${open ? '1px solid var(--stroke-system-border-overlay)' : 'none'}`,
            }}
        >
            <div
                className="header"
                onClick={() => {
                    setOpen(!open);
                }}
            >
                <div className="left">
                    <IconFont name={iconName} fontSize={16} color="--content-system-primary" />
                    <span className="wrap-title">{title}</span>
                </div>

                <div className="right">
                    <IconFont
                        name={open ? 'ChevronUpBold' : 'ChevronDownBold'}
                        fontSize={14}
                        color="--content-btn-transparency"
                    />
                </div>
            </div>
            {open ? <div className="content">{children}</div> : null}
        </div>
    );
};

export default EffectWrap;
